import React, {useEffect, useState} from 'react'
import {DESIGN_EDITOR_TAB, DESIGN_KEY_PREFIX} from "../../constants/design.constant";
import _ from 'lodash'
import ImageShape from "../design-editor/konva-editor/image-shape";

const ApplyParentProductColorListBox = ({
                                            parentProduct,
                                            selectedProductColor,
                                            setSelectedProductColor,
                                            selectedColors,
                                            addSelectedProductColorToVariant,
                                            removeSelectedProductColorFromVariant,
                                            containerClass
                                        }) => {
    const [selectedColorCodesList, setSelectedColorCodesList] = useState(null);

    useEffect(() => {
        setSelectedColorCodesList(_.map(selectedColors, 'code'));
    }, [selectedColors]);

    return (
        <>
            <div className="text-white text-center font-bold py-4 bg-gray-400 top-0 sticky">
                Product Colors (Background)
            </div>

            <div
                className={`overflow-y-scroll ${containerClass ? containerClass : 'design-editor-product-color-container-vertical'}`}>
                <div className="text-center py-2 text-lg bg-gray-300 sticky top-0 text-gray-700">Added Colors</div>

                <div
                    className="flex flex-wrap justify-center content-start my-2">
                    {parentProduct?.colors?.map((colorDetail, index) => {
                        return <React.Fragment key={`color-${index}`}>
                            {colorDetail.code && selectedColorCodesList?.indexOf(colorDetail.code) !== -1 &&
                                <div className={`m-1 p-1 border w-32 rounded cursor-pointer content-between grid grid-cols-1 bg-gray-300
                                 ${colorDetail.code ? 'text-white' : 'text-black'} ${colorDetail.name === 'White' ? 'text-black' : ''}`}>

                                    <div onClick={() => setSelectedProductColor(colorDetail)}
                                         style={{
                                             'backgroundColor': `${colorDetail.code}`,
                                             'borderColor': `${colorDetail.code}`
                                         }}
                                         className="text-center py-4 rounded">
                                        {colorDetail?.name}
                                    </div>

                                    {removeSelectedProductColorFromVariant &&
                                        <>
                                            <div className="mt-1">
                                                <button onClick={() => {
                                                    removeSelectedProductColorFromVariant(colorDetail);
                                                }} className="button-outline-red h-8 w-full m-auto">
                                                    Remove
                                                </button>
                                            </div>
                                        </>
                                    }
                                </div>
                            }
                        </React.Fragment>
                    })}
                </div>

                {addSelectedProductColorToVariant &&

                    <>
                        <div className="text-center py-2 text-lg bg-gray-300 sticky top-0 text-gray-700">Available
                            Colors
                        </div>

                        <div
                            className="flex flex-wrap justify-center content-start my-2">
                            {parentProduct?.colors?.map((colorDetail, index) => {
                                return <React.Fragment key={`color-${index}`}>
                                    {colorDetail.code && !selectedColorCodesList || selectedColorCodesList?.indexOf(colorDetail.code) === -1 &&
                                        <div className={`m-1 p-1 w-32 rounded cursor-pointer content-between grid grid-cols-1 bg-gray-300
                                ${colorDetail.code ? 'text-white' : 'text-black'} ${colorDetail.name === 'White' ? 'text-black' : ''}`}>

                                            <div onClick={() => setSelectedProductColor(colorDetail)}
                                                 style={{
                                                     'backgroundColor': `${colorDetail.code}`,
                                                     'borderColor': `${colorDetail.code}`
                                                 }}
                                                 className="text-center py-4 rounded">
                                                {colorDetail?.name}
                                            </div>

                                            <div className="mt-1">
                                                <button onClick={() => {
                                                    addSelectedProductColorToVariant(colorDetail);
                                                }} className="button-outline-green px-2 py-1 w-full m-auto">
                                                    Add
                                                </button>
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            })}
                        </div>
                    </>

                }

            </div>
        </>
    )
}


export default ApplyParentProductColorListBox
